// extracted by css-extract-rspack-plugin
export default {"pinMapButton":"_uYcm"};